import { AsteriskIcon } from './AsteriskIcon';

/**
 * author: Michael Irigoyen
 * id E8C373FE-4258-4341-B52A-E33D9A484968
 * name asterisk
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/asterisk.svg
 * tags
 */
export const RequiredIcon = AsteriskIcon;
export default RequiredIcon